import * as React from 'react';
import {LazyMotion, MotionConfig} from 'framer-motion';
import {transition} from './tokens';

const isTest = process.env.NODE_ENV === 'test';

const loadFeatures = () => import('./features').then((mod) => mod.default);

type MotionProviderProps = {
  children: React.ReactNode;
};

export function MotionProvider({children}: MotionProviderProps) {
  return (
    <LazyMotion strict={false} features={loadFeatures}>
      <MotionConfig transition={transition.default} skipAnimations={isTest}>
        {children}
      </MotionConfig>
    </LazyMotion>
  );
}
